import React, { useEffect, useRef, useState } from "react";
import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { getDomTop } from "@/common/utils";
import style from "./index.module.scss";

import LoginBox from "./LoginBox";

import img1 from "@/assets/images/fl84-kv-bg2.png";
import img2 from "@/assets/images/fl84-kv-hero.png";
import img3 from "@/assets/images/fl84-border1.png";
import img4 from "@/assets/images/fl84-border2.jpg";

import tier1 from "@/assets/images/fl84-lv1.png";
import tier2 from "@/assets/images/fl84-lv2.png";
import tier3 from "@/assets/images/fl84-lv3.png";

import seaHead1 from "@/assets/images/sea_0609_icon1.jpg";
import seaHead2 from "@/assets/images/sea_0609_icon2.jpg";
import seaHead3 from "@/assets/images/sea_0609_icon3.jpg";
import seaHead4 from "@/assets/images/sea_0609_icon4.jpg";

import seaPic1 from "@/assets/images/sea_0609_img1.jpg";
import seaPic2 from "@/assets/images/sea_0609_img2.jpg";
import seaPic3 from "@/assets/images/sea_0609_img3.jpg";
import seaPic4 from "@/assets/images/sea_0609_img4.jpg";

const ceatorData = [
  {
    head: seaHead1,
    line: "https://www.youtube.com/@LOUDLZINN/videos",
    name: "LOUD LZINN",
    videoImg: seaPic1,
    vid: "astbxjP2fZQ",
    followers: "1.28M",
    upDate: "2023-07"
  },
  {
    head: seaHead2,
    line: "https://www.youtube.com/@DuckyTheGamer",
    name: "DuckyTheGamer",
    videoImg: seaPic2,
    vid: "JeGxKPVa8Es",
    followers: "972K",
    upDate: "2023-07",
    isShort: true
  },
  {
    head: seaHead3,
    line: "https://www.youtube.com/@smithzerax12/videos",
    name: "SMITH",
    videoImg: seaPic3,
    vid: "X1nywe_VczY",
    followers: "711K",
    upDate: "2023-07"
  },
  {
    head: seaHead4,
    line: "https://www.youtube.com/@WorryBear",
    name: "WorryBear",
    videoImg: seaPic4,
    vid: "lAyB9NkuSSc",
    followers: "576K",
    upDate: "2023-07"
  },
];

const youtubeOpts = {
  window: 640,
  height: 390,
  playerVars: {
    autoplay: 1,
  }
};

import YouTube from "react-youtube";
import { fl84HomeData } from "@/assets/data/pageData";

let interestTimeInterval = -1;

function Fl84Home() {

  const [finLoadImg, setFinLoadImg] = useState(false);
  const [kvShrink, setKvShrink] = useState(false);
  const [contentBorderExpand, setContentBorderExpand] = useState(false);
  const [interestActive, setInterestActive] = useState(null);
  const [interestTime, setInterestTime] = useState(0);
  const [tierActive1, setTierActive1] = useState(null);
  const [tierActive2, setTierActive2] = useState(null);
  const [tierBack, setTierBack] = useState(null);
  const [loadCreatorImg, setLoadCreatorImg] = useState(false);
  const [creatorActive1, setCreatorActive1] = useState(null);
  const [creatorActive2, setCreatorActive2] = useState(null);
  const [joinActive1, setJoinActive1] = useState(null);
  const [scaleNum, setScaleNum] = useState(1);
  const [kvHeight, setKVHeight] = useState(document.documentElement.clientHeight);
  const [homeMargin, setHomeMargin] = useState(0);
  const [activeYoutube, setActiveYoutube] = useState(false);
  const [youTubeVid, setYouTubeVid] = useState("");

  const homeRef = useRef();
  const tierRef = useRef();
  const creatorRef = useRef();
  const joinRef = useRef();

  if (!finLoadImg) {
    preLoadImg(() => setFinLoadImg(true));
  }

  function setInterestTimeInterval() {
    if (interestTimeInterval > 0) {
      return;
    }
    interestTimeInterval = setInterval(() => {
      setInterestTime(value => {
        const index = (value + 1) % 3;
        const swiper = document.querySelectorAll(".swiper")[0].swiper;
        swiper.slideTo(index);
        return index;
      });
    }, 5000);
  }

  function pageAnimate() {
    const scale = getScaleNum();
    const vh = document.documentElement.clientHeight / scale;
    const st = document.documentElement.scrollTop / scale;
    if (st > vh / 4) {
      setKvShrink(true);
      setInterestActive(0);
      setContentBorderExpand(true);
      if (interestTimeInterval < 0) {
        interestTimeInterval = 0;
        setTimeout(setInterestTimeInterval, 500);
      }
    } else {
      setKvShrink(false);
      setInterestActive(-1);
      if (interestTimeInterval > 0) {
        clearInterval(interestTimeInterval);
        interestTimeInterval = -1;
      }
      return;
    }
    const top1 = st + vh * 0.5;
    const top2 = st + vh * 0.75;
    const top3 = st + vh * 0.4;
    const tierContentTop = getDomTop(tierRef.current);
    if (top1 > tierContentTop) {
      setTierActive2(0);
      setInterestActive(1);
    } else if (top2 > tierContentTop) {
      setTierActive1(0);
      setInterestActive(0);
      setLoadCreatorImg(true);
    } else {
      setTierActive1(-1);
      setTierActive2(-1);
      return;
    }
    const creatorContentTop = getDomTop(creatorRef.current);
    if (top1 > creatorContentTop) {
      setCreatorActive2(0);
      setTierBack(1);
    } else if (top2 > creatorContentTop) {
      setCreatorActive1(0);
      setTierBack(0);
    } else {
      setCreatorActive1(-1);
      setCreatorActive2(-1);
      return;
    }
    const joinContentTop = getDomTop(joinRef.current);
    if (top3 > joinContentTop) {
      setCreatorActive1(1);
      setCreatorActive2(1);
    } else if (top1 > joinContentTop) {
      setJoinActive1(0);
    } else {
      setCreatorActive1(0);
      setCreatorActive2(0);
      setJoinActive1(-1);
    }
  }

  function getScaleNum() {
    const vw = document.documentElement.clientWidth;
    if (vw > 1750 && vw < 1920) {
      return 1;
    } else if (vw < 1750) {
      return vw / 1750;
    } else {
      return vw / 1920;
    }
  }

  function scalePage() {
    const vw = document.documentElement.clientWidth;
    if (vw > 1750 && vw < 1920) {
      setScaleNum(1);
      setKVHeight(document.documentElement.clientHeight);
      setHomeMargin(0);
    } else if (vw < 1750) {
      setScaleNum(vw / 1750);
      setTimeout(() => { reSetHeight(vw / 1750); }, 100);
    } else {
      setScaleNum(vw / 1920);
      setTimeout(() => { reSetHeight(vw / 1920); }, 100);
    }
    pageAnimate();
  }

  function reSetHeight(scale) {
    const vh = document.documentElement.clientHeight;
    const kvHeight = vh / scale;
    // 3585
    const homeHeight = kvHeight + 3585 - (vh * 0.4);
    setKVHeight(kvHeight);
    setHomeMargin(homeHeight * (1 - scale));
  }

  function changeSwiper(index) {
    const swiper = document.querySelectorAll(".swiper")[1].swiper;
    if (!swiper) {
      return;
    }
    if (index > 0) {
      swiper.slideNext();
      return;
    }
    if (index < 0) {
      swiper.slidePrev();
      return;
    }
  }

  const onReady = (event) => {
    event.target.pauseVideo();
  };

  const playYoutube = (vid) => {
    setYouTubeVid(vid);
    setActiveYoutube(true);
  };

  const charSwiperChange = (swiper) => {
    setInterestTime(swiper.activeIndex % 3);
  };

  useEffect(() => {
    const scrollEven = pageAnimate;
    const resizeEven = scalePage;
    window.addEventListener("scroll", scrollEven);
    window.addEventListener("resize", resizeEven);
    resizeEven();
    scrollEven();
    reSetHeight();
    return () => {
      window.removeEventListener("scroll", scrollEven);
      window.removeEventListener("resize", resizeEven);
      if (interestTimeInterval > 0) {
        clearTimeout(interestTimeInterval);
      }
    };
  }, []);

  return (
    <>
      <div className={style.fl84Home} ref={homeRef} style={{ transform: `scale(${scaleNum})`, marginBottom: -homeMargin }}>
        <div className={`${style.kv} ${kvShrink ? style.shrink : ""}`} style={{ height: kvHeight }}>
          {
            finLoadImg && (
              <>
                <div className={style.kvMask}>
                  <div className={style.kvMaskBg} style={{ height: kvHeight, width: 1458 / scaleNum }}></div>
                </div>
                <div className={style.kvMan}></div>
                <h1 className={style.kvSlogan}>{fl84HomeData.slogan}</h1>
                <div className={style.loginBox}>
                  <LoginBox />
                </div>
              </>
            )
          }
        </div>
        <div className={style.content}>
          <div className={style.contentBorder1}>
            <div className={`${style.contentBorder1Box} ${style.expand}`}>
              <div className={style.contentBorder1Bg}></div>
            </div>
            <div className={`${style.borderPoint1} ${contentBorderExpand ? style.expand : ""}`}>
              <div className={style.pointMask1}>
                <div className={style.pointBg1}></div>
              </div>
            </div>
          </div>
          <div className={style.contentBorder2}>
            <div className={`${style.contentBorder2Box} ${contentBorderExpand ? style.expand : ""}`}>
              <div className={style.contentBorder2Bg}></div>
            </div>
            <div className={`${style.borderPoint2} ${contentBorderExpand ? style.expand : ""}`}>
              <div className={style.pointMask2}>
                <div className={style.pointBg2}></div>
              </div>
            </div>
          </div>
          <div className={
            ` ${style.interest}
            ${interestActive >= 0 ? style.active : ""}
            ${interestActive > 0 ? style.up : ""}
            ${interestActive < 0 ? style.down : ""}
          `
          }>
            <p className={style.title}>{fl84HomeData.perkTitle}</p>
            <p className={style.desc1}>{fl84HomeData.perkDesc}</p>
            <div className={`${style.descContent} ${interestTime === 0 ? style.active : ""}`}>
              <div className={style.title2Content}><p className={style.title2}>{fl84HomeData.perkSubTitle1}</p></div>
              <div className={style.desc2Content}><p className={style.desc2}>{fl84HomeData.perkSubDesc1}</p></div>
              <div className={style.charContent}>
                <div className={`${style.char} ${style.char1}`}></div>
              </div>
            </div>
            <div className={`${style.descContent} ${interestTime === 1 ? style.active : ""}`}>
              <div className={style.title2Content}><p className={style.title2}>{fl84HomeData.perkSubTitle2}</p></div>
              <div className={style.desc2Content}>
                <p className={style.desc2}>{fl84HomeData.perkSubDesc2}</p>
              </div>
              <div className={style.charContent}>
                <div className={`${style.char} ${style.char2}`}></div>
              </div>
            </div>
            <div className={`${style.descContent} ${interestTime === 2 ? style.active : ""}`}>
              <div className={style.title2Content}><p className={style.title2}>{fl84HomeData.perkSubTitle3}</p></div>
              <div className={style.desc2Content}>
                <p className={style.desc2}>{fl84HomeData.perkSubDesc3}</p></div>
              <div className={style.charContent}>
                <div className={`${style.char} ${style.char3}`}></div>
              </div>
            </div>
            <div className={style.exchangeLink}>
              <div className={`${interestTime === 0 ? style.active : ""}`} onClick={() => { setInterestTime(0); }}></div>
              <div className={`${interestTime === 1 ? style.active : ""}`} onClick={() => { setInterestTime(1); }}></div>
              <div className={`${interestTime === 2 ? style.active : ""}`} onClick={() => { setInterestTime(2); }}></div>
            </div>
            <div className={style.charSwiperMask}>
              <Swiper loop={true} onSlideChange={(swiper) => { charSwiperChange(swiper); }}>
                <SwiperSlide><div className={style.charSwiper}></div></SwiperSlide>
                <SwiperSlide><div className={style.charSwiper}></div></SwiperSlide>
                <SwiperSlide><div className={style.charSwiper}></div></SwiperSlide>
              </Swiper>
            </div>
          </div>
          <div className={`${style.tier} ${tierBack >= 0 ? style.active : ""} ${tierBack > 0 ? style.up : ""}`} ref={tierRef}>
            <div className={`${style.title} ${tierActive1 >= 0 ? style.active : ""} ${tierActive1 < 0 ? style.down : ""}`}><h2>{fl84HomeData.tierTitle}</h2></div>
            <p className={`${style.tierDesc} ${tierActive1 >= 0 ? style.active : ""} ${tierActive1 < 0 ? style.down : ""}`}>{fl84HomeData.tierDesc}</p>
            <div className={`${style.tierMain}`}>
              <div className={`${style.tierItem} ${style.tierItem1} ${tierActive2 >= 0 ? style.active : ""}`}>
                <div className={style.tierData}>
                  <img src={tier1}></img>
                  <p className={style.t1}>{fl84HomeData.tierItem1.title}</p>
                  <p className={style.t1}>{fl84HomeData.tierItem1.name}</p>
                  <div className={style.descBox}>
                    {
                      fl84HomeData.tierItem1.desc.map((item) => (
                        <>
                          <p>{item}</p>
                          <p>&nbsp;</p>
                        </>
                      ))
                    }
                  </div>
                </div>
              </div>
              <div className={`${style.tierItem} ${style.tierItem2} ${tierActive2 >= 0 ? style.active : ""}`}>
                <div className={style.tierData}>
                  <img src={tier2}></img>
                  <p className={style.t1}>{fl84HomeData.tierItem2.title}</p>
                  <p className={style.t1}>{fl84HomeData.tierItem2.name}</p>
                  <div className={style.descBox}>
                    {
                      fl84HomeData.tierItem2.desc.map((item) => (
                        <>
                          <p>{item}</p>
                        </>
                      ))
                    }
                  </div>
                </div>
              </div>
              <div className={`${style.tierItem} ${style.tierItem3} ${tierActive2 >= 0 ? style.active : ""}`}>
                <div className={style.tierData}>
                  <img src={tier3}></img>
                  <p className={style.t1}>{fl84HomeData.tierItem3.title}</p>
                  <p className={style.t1}>{fl84HomeData.tierItem3.name}</p>
                  <div className={style.descBox}>
                    {
                      fl84HomeData.tierItem3.desc.map((item) => (
                        <>
                          <p>{item}</p>
                        </>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${style.creators} ${creatorActive1 >= 0 ? style.active : ""} ${creatorActive1 === 1 ? style.up : ""}`} ref={creatorRef}>
            <div className={`${style.title} ${creatorActive1 >= 0 ? style.active : ""} ${creatorActive1 < 0 ? style.down : ""}`}><p>{ fl84HomeData.starTitle }</p></div>
            <div className={`${style.creatorBox} ${creatorActive2 >= 0 ? style.active : ""} ${creatorActive2 < 0 ? style.down : ""}`}>
              <Swiper
                modules={[Autoplay]}
                loop={true}
                autoplay={{ delay: 4000, stopOnLastSlide: false, disableOnInteraction: false }}
              >
                {
                  ceatorData.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div className={style.creatorData}>
                        <a href={item.line} target="_blank" rel="noreferrer">
                          <img className={style.userHeader} src={loadCreatorImg ? item.head : ""}></img>
                        </a>
                        <p className={`${style.userName} ${item.isShort ? style.short : ""}`}>{item.name}<i className={style.point}></i></p>
                        <div className={`${style.media} ${style.youtube}`}></div>
                        <ul className={style.mediaInfo}>
                          <li>
                            <span>{item.followers}</span>
                            <span>subscribers</span>
                          </li>
                        </ul>
                        <p className={style.update}>Latest Updated on: {item.upDate}</p>
                        <div className={style.videoBox}>
                          <img src={loadCreatorImg ? item.videoImg : ""}></img>
                          <div className={style.playMask}><a onClick={() => { playYoutube(item.vid); }}></a></div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))
                }
              </Swiper>
              <a className={style.left} onClick={() => { changeSwiper(-1); }}></a>
              <a className={style.right} onClick={() => { changeSwiper(1); }}></a>
            </div>
          </div>
          <div className={`${style.join} ${joinActive1 === 0 ? style.active : ""} ${joinActive1 < 0 ? style.down : ""}`} ref={joinRef}>
            <div className={style.darkBg}></div>
            <div className={style.dark}></div>
            <p>
              {
                fl84HomeData.joinDesc.map(item => (
                  <>
                    {item}<br />
                  </>
                ))
              }
            </p>
            <a className={style.joinBtn} onClick={() => { document.documentElement.scrollTo(0, 0); }}>{fl84HomeData.joinBtn}</a>
          </div>
        </div>
      </div>
      {
        activeYoutube && (
          <div className="youtube_play_box">
            <div className="youtube-close" onClick={() => setActiveYoutube(false)}></div>
            <YouTube
              videoId={youTubeVid}
              className="embed-youtube"
              opts={youtubeOpts}
              onReady={onReady}
            />
          </div>
        )
      }
    </>

  );
}

const loadingImg = [img1, img2, img3, img4];
// 预加载图片
function preLoadImg(finLoad) {
  const loadingImgFin = (index) => {
    loadingImg[index] = false;
    if (loadingImg.filter(item => item).length <= 0) {
      finLoad();
    }
  };
  if (loadingImg.filter(item => item).length <= 0) {
    finLoad();
  }
  loadingImg.forEach((item, index) => {
    const img = new Image();
    img.onload = () => loadingImgFin(index);
    img.src = item;
  });
}

export default Fl84Home;
